import { render, staticRenderFns } from "./ChatCarousel.vue?vue&type=template&id=b21dcfa8&scoped=true&"
import script from "./ChatCarousel.vue?vue&type=script&lang=js&"
export * from "./ChatCarousel.vue?vue&type=script&lang=js&"
import style0 from "./ChatCarousel.vue?vue&type=style&index=0&id=b21dcfa8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b21dcfa8",
  null
  
)

export default component.exports